import React from 'react'
import { Route } from 'react-router-dom'

const RouteIf = ({ condition, privateRoute, path, component }) => {
  return condition
    ? <Route path={path} component={component} />
    : null
}

export default RouteIf



// WEBPACK FOOTER //
// ./src/routes/RouteIf.jsx